import { DateTimeContext } from "@/providers/DateTimeProvider";
import type { DateTimeContextProps } from "@/types/providers/dateTime";
import { useContext } from "react";

export default function useDateTime(): DateTimeContextProps {
  const context = useContext(DateTimeContext);
  if (!context) {
    throw new Error("useDateTime must be used within a DateTimeProvider");
  }
  return context;
}
